// prettier-ignore
import buildGqlQuery from './buildGqlQuery';

export const adminOnly = buildGqlQuery('isAdmin', {}, 'me { access { system } }');
export const nonParent = (user) => (user && user.type !== 'PARENT');
export const nonStudent = (user) => (user && user.type !== 'STUDENT');
export const anyone = () => (true);
